import { t } from "@lingui/macro";
import { Helper } from "../../../../containers/AppPage/Reports/Ledger/helper";
import { StorageKey } from "../../../../enums/StorageKey";
import { AmountTdWidth } from "../../../Table/Common/AmountTd";

function getColumns(props) {
    const { reportData } = props;

    const currencySymbol = reportData?.company?.currency_symbol;

    return [
        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderDate,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber,
        },
        // {
        //     key: 'type',
        //     dataKey: 'type',
        //     title: t`Type`,
        //     width: 0,
        //     flexGrow: 15,
        //     cellRenderer: Helper.renderType,
        // },
        {
            key: 'contact_name',
            dataKey: 'contact_name',
            title: t`Contact`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderContact,
        },
        {
            title: t`Contact Code`,
            key: 'contact_code',
            cellRenderer: Helper.renderContactCode,
            width: 0,
            flexGrow: 15,
        },
        // {
        //     key: 'number2',
        //     dataKey: 'number2',
        //     title: t`Reference No.`,
        //     width: 0,
        //     flexGrow: 14,
        //     cellRenderer: Helper.renderNumber2,

        // },
        {
            key: 'description',
            dataKey: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderDescription,
        },
        // {
        //     key: 'title',
        //     dataKey: 'title',
        //     title: t`Title`,
        //     width: 0,
        //     flexGrow: 12,
        //     cellRenderer: Helper.renderTitle,
        // },
        {
            key: 'base_gain_amount',
            dataKey: 'base_gain_amount',
            title: t`Gain Amount`,
            align: 'right',
            width: AmountTdWidth,
            flexGrow: 0,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_gain_amount, currencySymbol),
        },

        // Custom fields
        // ...CustomFieldHelper.getColumnsBaseTable(fields.transaction),
    ];
}

export default {
    storageKey: StorageKey.report_unrealised_exchange_detail,
    getReportLabel: () => t`Unrealised Exchange Detail`,
    required: [
        'date',
        'number',
        'base_gain_amount',
    ],
    defaulto: [
        // 'type',
        'contact_name',
        'description',
    ],
    getColumns,
};
